import { NoiseOverlay } from "@/components/landing/NoiseOverlay";
import { Header } from "@/components/landing/Header";
import { Hero } from "@/components/landing/Hero";
import { VideoShowcase } from "@/components/landing/VideoShowcase";
import { Manifesto } from "@/components/landing/Manifesto";
import { Contact } from "@/components/landing/Contact";
import { Footer } from "@/components/landing/Footer";
import { AdminPanel } from "@/components/landing/AdminPanel";

export default function Landing() {
  return (
    <div className="relative min-h-screen bg-[#050505]">
      <NoiseOverlay />
      <Header />
      <main>
        <Hero />
        <VideoShowcase />
        <Manifesto />
        <Contact />
      </main>
      <Footer />
      <AdminPanel />
    </div>
  );
}
